module.exports = __webpack_public_path__ + "img/BRI.e8f4a390.svg";